export const currencies = ["KES-Kenya Shillings", "USD-US Dollars"];
export const paymentModes = ["Cash", "Bank Transfer", "Cheque", "Mobile Money"];
export const companies = ["Valent", "Slypeak", "Birongo"];
export const accounts = [
  "Cash",
  "Bank",
  "Customer Overpayments",
  "Our Overpayments",
  "Inventory",
  "Accounts Receivable",
  "Accounts Payable",
  "Equity",
  "Loans Payable",
  "Retained Earnings",
];

export const products = ["Flight", "Hotel Booking", "Car Hire"];
